
import './App.css';
import Translate from './Component/translate';

function App() {
  return(
    <>
    <Translate/>
    </>

  ) ;
  
  
}

export default App;
